
import { useScenario} from "../../contexts/ScenarioContext"

import RevealTable from "../RevealTable"

const GeneralTabContent = () => {
    const { generalFindings } = useScenario()
     
 
    return (
            <RevealTable
                title="LOC"
                category="general"
                headings={["Assessments", "Current Value"]}
                rows={generalFindings}
            />
    )
}

export default GeneralTabContent